var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.002 0C5.37484 0 0.00134277 5.50743 0.00134277 12.306C0.00134277 17.7438 3.44081 22.3512 8.20892 23.9798C8.80895 24.0923 9.02861 23.712 9.02861 23.3852C9.02861 23.0905 9.01789 22.319 9.01253 21.2904C5.67486 22.0351 4.96768 19.6403 4.96768 19.6403C4.42122 18.2206 3.63368 17.8402 3.63368 17.8402C2.54612 17.0741 3.71404 17.0902 3.71404 17.0902C4.91946 17.1759 5.55164 18.3599 5.55164 18.3599C6.62312 20.2404 8.35893 19.6993 9.04468 19.3832C9.15183 18.5903 9.46256 18.0438 9.80543 17.7384C7.14279 17.4277 4.34086 16.3723 4.34086 11.6578C4.34086 10.313 4.80695 9.21477 5.57307 8.35758C5.44984 8.04685 5.03732 6.79322 5.69093 5.10027C5.69093 5.10027 6.69813 4.76811 8.9911 6.35926C9.95008 6.08604 10.9734 5.9521 11.9966 5.94674C13.0145 5.9521 14.0432 6.08604 15.0021 6.35926C17.2951 4.76811 18.297 5.10027 18.297 5.10027C18.9506 6.79322 18.538 8.04685 18.4148 8.35758C19.1809 9.22013 19.647 10.3184 19.647 11.6578C19.647 16.383 16.8397 17.4223 14.1664 17.7277C14.595 18.1081 14.9807 18.8581 14.9807 20.0046C14.9807 21.6494 14.9646 22.978 14.9646 23.3798C14.9646 23.7066 15.1789 24.0923 15.7897 23.9691C20.5685 22.3458 24.0026 17.7384 24.0026 12.306C24.0026 5.50743 18.6291 0 12.002 0Z",
    fill: "#A7A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.91c1e96d88e6501a473917c7f46b8de2.svg";
export { ForwardRef as ReactComponent };